import React from 'react';
import { cn } from '@/lib/utils';
import SiteImage from '../SiteImage';
import CoasterDesign from './CoasterDesign';
import { TIER_PHOTOS, tierExample } from './pricingModel';

/**
 * A tier's example coaster on a plan card (Pricing, For Businesses, Home): the tier photo with
 * the example artwork composited in (TIER_PHOTOS; Standard: the shared back with one logo space
 * ringed; Venue Sponsor: front and back together), framed 5:4 so no coaster is cut, an
 * "Example" tag, the example line (tierExample) and "View the design" (the flat art, whole, in a
 * dialog). Text takes the card's colour.
 *
 * Props: `tier` (a live tier: tier_key, name, slots_per_venue), `sizes`, `bleed` (a class string
 * that pulls the photo to the card's edges), `className`.
 */
export default function TierCoaster({ tier, sizes, bleed, className }) {
  const key = tier && tier.tier_key;
  const photo = TIER_PHOTOS[key];
  if (!photo) return null;
  const name = tier.name || key;
  return (
    <figure className={cn('m-0 mb-5', className)} data-tier-coaster={key}>
      <div className={cn('relative', bleed)}>
        <SiteImage id={photo} ratio="1x1" box="5x4" tone="paper" sizes={sizes} className="border border-navy/15" />
        <span className="absolute left-2.5 top-2.5 bg-navy px-2 py-1 font-label text-[11px] uppercase tracking-[0.06em] text-brand-sheet">
          Example
        </span>
      </div>
      <figcaption className="mt-2.5 text-[0.8125rem] leading-snug" data-testid="tier-example">
        {tierExample(key, tier.slots_per_venue)}{' '}
        <CoasterDesign
          tier={key}
          tierName={name}
          spaces={tier.slots_per_venue}
          className="inline font-semibold underline decoration-1 underline-offset-4 hover:opacity-80"
        />
      </figcaption>
    </figure>
  );
}
